import { gql } from "generated-graphql";

import type { ScoutConversationHistoryLoader } from "../../Customer/Scout/hooks/scoutConversationController";

export const GET_SCOUT_CONVERSATION_HISTORY_FOR_STAFF = gql(`
  query GetScoutConversationHistoryForStaff($conversationId: ID!) {
    getScoutConversationHistoryForStaff(conversationId: $conversationId) {
      conversationId
      title
      status
      createdAt
      updatedAt
      tenant {
        id
        name
      }
      user {
        id
        email
        firstName
        lastName
      }
      usage {
        model
        inputTokens
        outputTokens
        thinkingTokens
        cacheReadTokens
        cacheWriteTokens
        estimatedCostUsd
      }
      messages {
        id
        role
        seq
        lastStreamEntryId
        requestId
        createdAt
        updatedAt
        provider
        model
        inputTokens
        outputTokens
        thinkingTokens
        cacheReadTokens
        cacheWriteTokens
        estimatedCostUsd
        parts {
          id
          seq
          type
          streamPartId
          stepIndex
          agentState
          text
          toolName
          toolDisplayName
          toolCallId
          toolState
          toolInput
          toolOutput
          toolError
          toolTokenEstimate
          toolDurationMs
          sourceId
          url
          title
          mediaType
          filename
          createdAt
          document {
            id
            signedDownloadUrl
            ingestionMode
            extractionStatus
          }
        }
      }
    }
  }
`);

export const staffScoutHistoryLoader: ScoutConversationHistoryLoader = async ({
  conversationId,
  apolloClient,
  forceNetwork,
}) => {
  const result = await apolloClient.query({
    query: GET_SCOUT_CONVERSATION_HISTORY_FOR_STAFF,
    variables: { conversationId },
    fetchPolicy: forceNetwork ? "network-only" : "cache-first",
  });

  const history = result.data?.getScoutConversationHistoryForStaff;
  if (!history) {
    return undefined;
  }

  return {
    conversationId: history.conversationId,
    title: history.title,
    messages: history.messages,
  };
};

export const staffScoutStreamUrlBuilder = ({
  conversationId,
}: {
  tenantId: string | undefined;
  conversationId: string | undefined;
}) => {
  if (!conversationId) {
    return "/events/scout/disabled";
  }

  return `/events/staff/scout/${conversationId}`;
};
